export const GET_INDUSTRIES = 'GET_INDUSTRIES';
export const GET_INDUSTRIES_SUCCESS = `${GET_INDUSTRIES}_SUCCESS`;
export const GET_INDUSTRIES_ERROR = `${GET_INDUSTRIES}_ERROR`;

export const getIndustriesAction = {
  type: GET_INDUSTRIES,
};
